import Vue from 'vue'
import App from './App.vue'
import moment from 'moment'
import animate from 'animate.css'
import { createRouter } from './router'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import { sync } from 'vuex-router-sync'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.prototype.$moment = moment
Vue.use(animate)
Vue.use(Antd)
Vue.use(ElementUI)

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
  ak: '3wd7NiZAXPIBVNnjXb72ispm33C3iPPd'
})

//关闭生产模式下给出的提示
Vue.config.productionTip = true

// for using vant components
import Vant from 'vant'
Vue.use(Vant)
// 控制服务端渲染时候，返回HTML移除三方css，转为 preload 加载，前提: 默认支持的 preload 加载
if (process.env.VUE_ENV === 'client') {
  require('vant/lib/index.css')
}

// global loading
Vue.prototype.$loading = (isLoading) => {
  if (isLoading) {
    Vue.prototype.$toast.loading({
      mask: true,
      message: '加载中...',
      overlayStyle: {
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
      },
      duration: 0
    })
  } else {
    Vue.prototype.$toast.clear()
  }
}
const router = createRouter()

// router.beforeEach(async (to, from, next) => {
//   const { data } = await axios.get(
//     Config.baseURL + `${baseUrl}/getSeo?url=` + to.fullPath
//   )
//   if (data.code === '00000') {
//     const head = document.getElementsByTagName('head')
//     const meta = document.createElement('meta')
//     document
//       .querySelector('meta[name="keywords"]')
//       .setAttribute('content', data.data.keywords)
//     document
//       .querySelector('meta[name="description"]')
//       .setAttribute('content', data.data.description)
//     document.title = data.data.title
//     meta.content = data.data.title
//     head[0].appendChild(meta)
//   }
//   next()
// })

export function createApp() {
  // const store = createStore()
  // sync the router with the vuex store.
  // this registers `store.state.route`
  sync(store, router)
  const app = new Vue({
    router,
    store,
    render: (h) => h(App)
  })
  return { app, router, store }
}

// promise.finally Polyfill
if (!Promise.prototype.finally) {
  Promise.prototype.finally = function (callback) {
    let P = this.constructor
    return this.then(
      (value) => P.resolve(callback()).then(() => value),
      (reason) =>
        P.resolve(callback()).then(() => {
          throw reason
        })
    )
  }
}
